export default __webpack_public_path__ + "static/media/PayoutInactive.b0e7999d.svg";